// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__GW6tF","hand":"Home_hand__ol-0R","wave":"Home_wave__ET3P5"};